export const INDEXDB_NAME = 'CasinoVersion2';
export const INDEXDB_SCHEMA = {
    lobbies:
        '++id, lobbyType, dataIdentifierKey, [dataIdentifierKey+lobbyType], templateName, invokerProduct, createdAt, lobbyGameIconImageSuffix, optSegName,collectionKey,lobbyTargetType',
    categories:
        '++id, categoryId, lobbyType, dataIdentifierKey, [dataIdentifierKey+lobbyType], route, categoryName, games, rowcount, lmtCategoryId, subCategoryVisible, engCategoryName,navigationCategory, lmtSubCategories, sitecoreData,collectionKey',
    subcategories:
        '++id, subcategoryId, route, subCategoryname, games, lmtCategoryId, categoryId, isSubCatVisible, engCategoryName,categoryName, sitecoreData, hideSubCategory, subTitle, parentCategoryId, parentLMTCategoryId, filterRecentlyPlayedGames, havingCasiaGames, filterFeatureIds, lobbyType, dataIdentifierKey, [dataIdentifierKey+lobbyType], linkedCategory, rowCount, collectionKey',
    gameMetaData: '++id, game, name, provider, metaLobbyType, ownerId, lobbyType, dataIdentifierKey, [dataIdentifierKey+lobbyType], collectionKey',
    stickerDetails: '++id, name, value, lobbyType, dataIdentifierKey, [dataIdentifierKey+lobbyType], collectionKey',
    categoryVsFeatureMetadata:
        '++id, featureIds, categoryId, subCategoryId, lobbyType, dataIdentifierKey, [dataIdentifierKey+lobbyType], collectionKey',
    categoryNameLangMap: '++id, name, value, lobbyType, dataIdentifierKey, [dataIdentifierKey+lobbyType], collectionKey',
};

export interface LobbyTable {
    lobbyType: string;
    templateName: string | undefined;
    invokerProduct: string;
    createdAt: number;
    lobbyGameIconImageSuffix: string;
    optSegName: string | undefined;
    dataIdentifierKey: string;
    collectionKey?: string;
    lobbyTargetType: string;
}

export interface CategoryTable {
    categoryId: string;
    lmtCategoryId: string;
    engCategoryName: string;
    lobbyType: string;
    categoryName: string;
    games: any[];
    route: string;
    rowcount: string | undefined;
    navigationCategory: boolean;
    subCategoryVisible: boolean;
    lmtSubCategories: string[] | undefined;
    sitecoreData: any;
    dataIdentifierKey: string;
    collectionKey?: string;
}

export interface SubCategoryTable {
    subcategoryId: string;
    parentCategoryId: string;
    categoryId: string;
    categoryName: string;
    subCategoryName: string;
    engCategoryName: string;
    filterRecentlyPlayedGames: boolean;
    games: any[];
    havingCasiaGames: boolean;
    hideSubCategory: boolean | undefined;
    isSubCatVisible: boolean;
    lmtCategoryId: string;
    parentLMTCategoryId: string;
    route: string;
    sitecoreData: any;
    subTitle: string;
    lobbyType: string;
    filterFeatureIds: any;
    linkedCategory: string;
    rowCount: string;
    dataIdentifierKey: string;
    collectionKey?: string;
}
export interface GameMetadataTable {
    game: string;
    name: string;
    provider: string;
    ownerId: string;
    metaLobbyType: string;
    dataIdentifierKey?: string;
    lobbyType: string;
    collectionKey?: string;
}

export interface StickerDetailsTable {
    name: string;
    value: string;
    lobbyType: string;
    dataIdentifierKey: string;
    collectionKey?: string;
}

export interface categoryVsFeatureMetadataTable {
    categoryId: string;
    subCategoryId?: string;
    featureIds: string[];
    lobbyType?: string;
    dataIdentifierKey?: string;
    collectionKey?: string;
}

export interface categoryNameLangTable {
    name: string;
    value: string;
    lobbyType: string;
    dataIdentifierKey: string;
    collectionKey?: string;
}

export const TABLES = {
    LOBBY: 'lobbies',
    CATEGORY: 'categories',
    SUB_CATEGORY: 'subcategories',
    GAME_METADATA: 'gameMetaData',
    CATEGORY_VS_FEATURE_METADATA: 'categoryVsFeatureMetadata',
    STICKER_DETAILS: 'stickerDetails',
    CATEGORY_NAME_LANG_MAP: 'categoryNameLangMap',
};

export const FIXEDPREFIX_TO_KEY = 'categoryCoreLookUp_';
